var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSunshadeClosedMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35,0H13c-2.7568359,0-5,2.2431641-5,5v38c0,2.7568359,2.2431641,5,5,5h22c2.7568359,0,5-2.2431641,5-5V5 C40,2.2431641,37.7568359,0,35,0z M38,43c0,1.6542969-1.3457031,3-3,3H13c-1.6542969,0-3-1.3457031-3-3V5 c0-1.6542969,1.3457031-3,3-3h22c1.6542969,0,3,1.3457031,3,3V43z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 34,
    width: 20,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 28,
    width: 20,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 22,
    width: 20,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 40,
    width: 20,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,7.4140625V14h2V7.4140625l2.2929688,2.2929688l1.4140625-1.4140625l-4-4 c-0.390625-0.390625-1.0234375-0.390625-1.4140625,0l-4,4l1.4140625,1.4140625L23,7.4140625z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunshadeClosedMedium);
export default __webpack_public_path__ + "static/media/sunshade-closed--medium.a61e5042bb6df73db9021ccc3a8dc60d.svg";
export { ForwardRef as ReactComponent };